import { FC, ReactNode } from 'react'

export const SafeAreaProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="h-full">
      <div className="h-full bg-cool-gray-900">{children}</div>
    </div>
  )
}
